// extracted by mini-css-extract-plugin
module.exports = {"cartHoverWrapper":"CartHover_cartHoverWrapper__1k6E2","itemWrapper":"CartHover_itemWrapper__10ccK","img":"CartHover_img__Njv9R","name":"CartHover_name__2A7fW","details":"CartHover_details__3nDMX","price":"CartHover_price__4cIqx"};
    if(module.hot) {
      // 1686459236068
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  